import assign from 'object-assign';
import View from '@core/View';
import pathOr from 'ramda/src/pathOr';
import ProductCatalogService from '@services/ProductCatalogService';

/**
 *  Deprecated -> uses legacy View module
 *  Recommendations Controller
 */
const
    recommendationsProto = {
        sku: null,
        skuRecommendations: [],
        view: new View( 'recommendationsCrossSell' ),

        renderAccessories: function () {
            const products = this.skuRecommendations.map( item => ({
                ...item,
                firstImageSrc: getItemImageSource( item )
            }) );
            return (products.length >= 1)
                ? this.view.render( {sku: this.sku, products} )
                : '';
        }
    },
    getItemImageSource = pathOr( '/', ['images', 0, 'source'] ),
    Recs = {
        create: function ( {accessories, ...rest} = {} ) {
            const proto = assign( {}, recommendationsProto, {
                sku: {...rest},
                skuRecommendations: accessories || []
            } );
            return Object.create( proto );
        }
    };

export default {
    async fetch ( sku ) {
        if ( typeof sku === 'undefined' ) {
            throw Error( 'upi.Recommendations: invalid sku param' );
        }

        const product = await ProductCatalogService.getDetailWithAccessories( sku );
        return Recs.create( product )
    }
};
